// Задает __webpack_public_path__, указывающий где лежат чанки, нужные для подключения асинхронных модулей
// Значение берется из дата-атрибута на скрипте
// Этот модуль должен быть импортирован в первую очередь!
// Подробнее https://webpack.js.org/guides/public-path/#on-the-fly

const entryScript = document.querySelector('script[data-task-type]');
let assetsPath = entryScript.dataset.assetsPath;
if (assetsPath[assetsPath.length - 1] !== '/') {
  assetsPath += '/';
}

if (assetsPath) {
  // eslint-disable-next-line camelcase, no-undef
  __webpack_public_path__ = assetsPath;
}

module.exports = {
  entryScript,
  assetsPath
};
